export default __webpack_public_path__ + "static/media/footprint-info-03.9de1ec8e.svg";